import mixpanel from 'mixpanel-browser';

export const clevertap = (window as any).clevertap;

export const pushEvent = (eventName: string, payload?: any) => {
    clevertap?.event.push(eventName, payload || {});

    if (window.mixpanel?.initialized) {
        mixpanel.track(eventName, payload);
    }
};
